export enum FeedbackFeatureEnum {
    GERMPLASM_LIST = 'GERMPLASM_LIST',
    MANAGE_PROGRAM_SETTINGS = 'MANAGE_PROGRAM_SETTINGS',
    GERMPLASM_AND_CHECKS = 'GERMPLASM_AND_CHECKS',
    ADVANCE_GERMPLASM = 'ADVANCE_GERMPLASM'
}
